import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { PAGE_SIZE } from 'core/utils/constants';
import httpclient from 'libs/Axios';
import { useEffect } from 'react';

export const useFetchCity = (list, setlist) => {
  const authData = useAuth();
  useEffect(() => {
    const request = async () => {
      // const response = await httpclient().get(`/master/city/list?${PAGE_SIZE}`);
      // const data = response?.data?.data;
      setlist(authData?.MASTER_DATA?.cityList || []);
    };

    request();
  }, []);
};
